import { FunctionalComponent, h } from '@stencil/core';
import get from 'lodash/get';

interface AppInputSelect {
    label:string;
    path: string;
    name: string;
    placeholder: string;
    value?: any;
    onChange: any;
    errors: any;
    required?: boolean;
    tip?: string;
    options: Array<string>;
}


export const AppInputSelect: FunctionalComponent<AppInputSelect> = ({ label, path, errors, name, placeholder, value, onChange, required, tip, options }) => {

    return (
        <div class="uk-margin">
            <label class="uk-form-label" uk-tooltip={tip}>{label} <span class="uk-text-danger">{required && '*'}</span> <span class="uk-text-danger">{get(errors, [path, 'message'])}</span></label>
            <div class="uk-form-controls">
                <select class={`uk-select ${get(errors, [path, 'message']) ? 'uk-form-danger' : ''}`} name={name} onChange={onChange}>
                    <option value="">{placeholder}</option>
                    {options.map(option => <option selected={option == value} value={option}>{option}</option>)}
                </select>
            </div>
        </div>
    )
};


